export enum TimeZones {
    Atlantic = "7004e24d-7d7f-4c23-a0e0-3dc61fbeecac",
    PuertoRico = "2b6f55c6-4e2c-4fff-9555-6379fbb81e5e",
    Eastern = "1edd6dc6-ceeb-4873-8441-dc2ec053fbdd",
    Central = "f872aa27-079f-477a-8688-69b51bcf996d",
    Mountain = "62a535ee-5799-4e08-b928-def3b3c15b19",
    Arizona = "c8d672c7-6faa-4000-bfad-d4ca445643cd",
    Pacific = "f63b90d8-bd45-46e7-97c6-735f805019d9",
    Alaskan = "f2bc7011-e112-4001-89bc-794a5eb585b4",
    Hawaiian = "c0415aac-2992-4853-a3c2-f999c41f8ae0",
}

export interface TimeZoneInfo {
    name: string;
    guid: TimeZones;
    offset: number;
    dst: boolean;
    officialName: string;
}

// offset from UTC and DST bool
export const TimeZoneOffsets: TimeZoneInfo[] = [
    { guid: TimeZones.Atlantic, name: "Atlantic", offset: 4, dst: true, officialName: "America/Halifax" },
    { guid: TimeZones.PuertoRico, name: "Puerto Rico", offset: 4, dst: false, officialName: "America/Puerto_Rico" },
    { guid: TimeZones.Eastern, name: "Eastern", offset: 5, dst: true, officialName: "America/New_York" },
    { guid: TimeZones.Central, name: "Central", offset: 6, dst: true, officialName: "America/Chicago" },
    { guid: TimeZones.Mountain, name: "Mountain", offset: 7, dst: true, officialName: "America/Denver" },
    { guid: TimeZones.Arizona, name: "Arizona", offset: 7, dst: false, officialName: "America/Phoenix" },
    { guid: TimeZones.Pacific, name: "Pacific", offset: 8, dst: true, officialName: "America/Los_Angeles" },
    { guid: TimeZones.Alaskan, name: "Alaskan", offset: 9, dst: true, officialName: "America/Anchorage" },
    { guid: TimeZones.Hawaiian, name: "Hawaiian", offset: 10, dst: false, officialName: "Pacific/Honolulu" },
];
